/**
 * Error class for MailboxInfo related exceptions thrown by the package, this creates a common
 * exception prefix that can be used in looking for MalilboxInfo related exceptions in telemetry
 */
export class MailboxInfoError extends Error {
    constructor(reason?: string) {
        super(`MailboxInfo error: ${reason}`);
    }
}
